import React from "react";

import DashboardCard
  from "./DashboardCard";

export default function PendingSatisfactionGrid({

  data = [],

  onViewAll,

  onOpen,

}) {

  return (

    <DashboardCard

      title="Pending Satisfaction"

      subtitle="Awaiting customer satisfaction"

      height={420}

      actions={

        <button
          className="btn btn-sm btn-outline-success"
          onClick={onViewAll}
        >
          View All
        </button>

      }

    >

      <div
        style={{
          overflow: "auto",
          height: "90%",
        }}
      >

        <table
          className="table table-sm table-hover"
        >

          <thead>

            <tr>

              <th>Ticket No</th>
              <th>Customer</th>
              <th>Engineer</th>
              <th>Action</th>

            </tr>

          </thead>

          <tbody>

            {data.length === 0 && (

              <tr>

                <td
                  colSpan="4"
                  className="text-center text-muted"
                >
                  No pending satisfaction
                </td>

              </tr>

            )}

            {data.map(
              (row, index) => (

              <tr key={index}>

                <td>{row.ticket_no}</td>

                <td>{row.customer_name}</td>

                <td>{row.assigned_engineer}</td>

                <td>

                  <button
                    className="btn btn-sm btn-success"
                    onClick={() =>
                      onOpen &&
                      onOpen(row)
                    }
                  >
                    Open
                  </button>

                </td>

              </tr>

            ))}

          </tbody>

        </table>

      </div>

    </DashboardCard>

  );
}